import { IGroup } from "@grassrootly/api";
import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";

export interface CreateGroup {
  create_group: { [key: string]: IGroup };
}

const initialState: CreateGroup = {
  create_group: {},
};

const createGroupSlice = initReducer({
  name: "create-group",
  initialState,
  reducers: {
    setCreateGroup: (state: CreateGroup, action: PayloadAction<IGroup[]>) => {
      action.payload.forEach((group) => {
        state.create_group[group.id] = group;
      });
    },
    cleanState: () => {
      return initialState;
    },
  },
});

const persistConfig: PersistConfig<CreateGroup> = {
  key: "create-group",
  storage: AsyncStorage,
};

export const createGroupActions = createGroupSlice.actions;

export default createPersistReducer(persistConfig, createGroupSlice.reducer);
